export default {
    setFeedArchive(state, payload) {
        const archives = (payload.archives || []).map(archive => ({
            ...archive,
            showDetailsTransaction: false,
            feedId: payload.feedId
        }));

        if (payload.append) {
            // Aynı diziye eklenir: bileşenlerin tuttuğu referans güncel kalır.
            state.feedArchive.push(...archives);
        } else {
            // Yer değiştirme de aynı dizi üzerinde yapılır (sayfa boyutu değişince bileşen referansı eskimesin).
            state.feedArchive.splice(0, state.feedArchive.length, ...archives);
        }

        state.feedId = payload.feedId;
        state.multiLanguage = payload.multiLanguage;
        state.dateFrom = payload.dateFrom;
        state.dateTo = payload.dateTo;
        state.pageNumber = payload.pageNumber;
        state.pageSize = payload.pageSize;
        state.totalCount = payload.totalCount;
    },
    setLoading(state, isLoading) {
        state.isLoading = isLoading;
    }
}
